import { useGetCurrentBoardId } from 'entities/user/api/hooks/useGetCurrentBoardId';
import { useGetUserBoards } from './useGetUserBoards';

export const useGetCurrentBoard = () => {
  const currentBoardId = useGetCurrentBoardId();

  const {
    data: boardsData,
    isError: isBoardsDataError,
    isLoading: isBoardsDataLoading,
  } = useGetUserBoards();

  return {
    board: boardsData?.data.find(({ id }) => id === currentBoardId),
    isCurrentBoardError: isBoardsDataError,
    isCurrentBoardLoading: isBoardsDataLoading,
  };
};
